import { Mail, MapPin, Phone, ArrowUpRight } from "lucide-react";

export default function ClosingComponent() {
  return (
    <footer className="bg-[#0F172A] px-6 md:px-12 lg:px-20 py-10 lg:py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto">

        {/* Top Section */}
        <div className="grid lg:grid-cols-2 gap-14 items-center">

          {/* Left Side */}
          <div>
            <p className="text-[#22C55E] uppercase tracking-[0.35em] text-xs mb-6">
              Contact Us
            </p>

            <h2 className="text-3xl md:text-5xl lg:text-5xl font-semibold text-white leading-tight">
              Let’s Work Together for{" "}
              <span className="text-[#22C55E]">
                Climate Impact
              </span>
            </h2>

            <p className="mt-5 lg:mt-8 text-white/70  md:text-lg leading-relaxed max-w-xl">
              We welcome partnerships, donor engagement, and collaboration opportunities.
            </p>

            {/* CTA */}
            <div className="mt-10">
              <a
                href="https://www.linkedin.com/company/anna-foundations/"
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-[#22C55E] hover:bg-white transition-all duration-300 text-black px-8 py-4 rounded-full  flex items-center gap-3 w-fit"
              >
                Partner With Us

                <ArrowUpRight className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300 w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Right Side */}
          <div className="bg-white/[0.04] border border-white/10 rounded-[32px] p-8 md:p-10 backdrop-blur-sm relative">

            {/* Glow (now visible green) */}
            <div className="absolute top-0 right-0 w-40 h-40 bg-[#22C55E]/20 blur-3xl rounded-full" />

            <div className="relative z-10 space-y-8">

              {/* Location */}
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 rounded-2xl bg-[#22C55E]/20 flex items-center justify-center shrink-0">
                  <MapPin className="text-[#22C55E] w-6 h-6" />
                </div>

                <div>
                  <p className="text-white lg:text-lg font-semibold mb-2">
                    Location
                  </p>

                  <p className="text-white/65 leading-relaxed text-xs md:text-md">
Plot 2450 Cadastral, Apo, Abuja, Nigeria                  </p>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 rounded-2xl bg-[#22C55E]/20 flex items-center justify-center shrink-0">
                  <Mail className="text-[#22C55E] w-6 h-6" />
                </div>

                <div>
                  <p className="text-white lg:text-lg font-semibold mb-2">
                    Email
                  </p>

                  <a
                    href="mailto:kanna@annafndtn.org"
                    className="text-white/65 hover:text-[#22C55E] transition text-xs md:text-md"
                  >
                    kanna@annafndtn.org
                  </a>
                </div>
              </div>

              {/* Phone */}
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 rounded-2xl bg-[#22C55E]/20 flex items-center justify-center shrink-0">
                  <Phone className="text-[#22C55E] w-6 h-6" />
                </div>

                <div>
                  <p className="text-white lg:text-lg font-semibold mb-2">
                    Phone
                  </p>

                  <p className="text-white/65 text-xs md:text-md">
                    +234 702 123 4567
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Bottom Line */}
        <div className="border-t border-white/10 mt-10 lg:mt-20 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">

          <p className="text-white/40 text-xs md:text-sm text-center md:text-left">
            © 2026 ANNA OKWARA Foundation. All rights reserved.
          </p>

          <p className="text-white/30 text-xs md:text-sm text-center md:text-right max-w-xl">
            Building sustainable systems for climate resilience, environmental
            stewardship, and empowered communities.
          </p>
        </div>

      </div>
    </footer>
  );
}